export default __webpack_public_path__ + "static/list-of-participants-7ca178b69f4d38fbe551b35a980e930f.png";